import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/react-hooks';
import { loog } from '@express-labs/raven-tools';
import { forgotPassword } from '../../../../graphql/mutation/index';
import ForgotPasswordForm from './ForgotPasswordForm';

function ForgotPasswordFormVM(props) {
  const [hasError, setHasError] = useState();
  const [showNotification, setShowNotification] = useState();
  
  const [onApplyChanges, { data, loading, error }] = useMutation(forgotPassword);

  useEffect(() => {
    if (!loading) {
      if (error) {
        loog(`Log in error: ${error}`, 'info', error);
        setHasError(true);  
      } else if (!error && data) {
        setShowNotification(true); 
      }
    }
  }, [data, error, loading]);

  const handleFormSubmit = useCallback((values) => onApplyChanges({
      variables: {
        email: values.email,
      },
    }).catch(() => 'invalid'), [onApplyChanges]);

  const mapProps = {
    handleCurrentForm: props.handleCurrentForm,
    handleFormSubmit,
    hasError,
    loading,
    showNotification,
  };
  return <ForgotPasswordForm {...mapProps} />;
}

ForgotPasswordFormVM.propTypes = {
  handleCurrentForm: PropTypes.func,
};

ForgotPasswordFormVM.defaultProps = {
  handleCurrentForm: null,
};

export default ForgotPasswordFormVM;
